import api from '../../../lib/api';

const pollActionForUserId = userId => {
	return api('get', `/api/poll/${userId}`);
};

export default pollActionForUserId;
